import { useContext } from "react"
import FormViewContext from './FormViewContext'
import useStyles from './styles'
import { readFieldValue } from 'shared/utils/formFieldValue'

const isObject = (v) => v !== null && typeof v === 'object'

export function Form({ children, initialData, changedData, errorFields, onDataChange, ...props }) {
  const classes = useStyles()
  const formViewContext = useContext(FormViewContext)

  const hasChanged = Boolean(changedData && Object.keys(changedData).length > 0)  

  const onFieldChange = (fieldName) => (value) => {
    if (value == getFieldValue(fieldName))
      return

    const fieldNames = fieldName.split(".")
    const key = fieldNames[0]
    const subKey = fieldNames.length > 1 && fieldNames[1]
    
    if (subKey)
      onDataChange(key, {
        ...(isObject(changedData?.[key]) ? changedData[key] : isObject(initialData?.[key]) ? initialData[key] : {}),
        [subKey]: value
      })
    else    
      onDataChange(fieldName, value)
  }
  
  const getFieldValue = (fieldName) => readFieldValue(changedData, initialData, fieldName)
  
  const getFieldError = (fieldName) => {
    return errorFields && errorFields[fieldName]
  }
  
  return (
    <>
      <FormViewContext.Provider value={{
          onFieldChange,
          getFieldValue,
          getFieldError,
        }}>
        { children }
      </FormViewContext.Provider>
    </>
  )
}

export default Form